import * as React from "react";
const SvgFail = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 6, stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.5 5.5L10.5 10.5", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5 5.5L5.5 10.5", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgFail;
